var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1519.43 1407.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-4 {\n        fill: url(#Degradado_sin_nombre_14);\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 22px;\n      }\n\n      .cls-2 {\n        font-family: Poppins-Bold, Poppins;\n        font-size: 143.31px;\n      }\n\n      .cls-3 {\n        fill: url(#Degradado_sin_nombre_13);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_13",
    "data-name": "Degradado sin nombre 13",
    x1: 770.96,
    y1: 59.03,
    x2: 770.96,
    y2: 891.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ac04b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06843a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_14",
    "data-name": "Degradado sin nombre 14",
    cx: 1144.5,
    cy: 2179.89,
    fx: 1144.5,
    fy: 2179.89,
    r: 486.3,
    gradientTransform: "translate(-577.62 -203.8) scale(1.17 .66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#008d40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bf4a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M770.98,59.03c-231.44,0-419.65,186.77-419.65,416.4,0,91.07,29.67,175.47,79.93,244.14l-52.4,154.61,161.23-51.23c66.24,43.46,145.62,68.84,230.89,68.84,231.35,0,419.61-186.78,419.61-416.36S1002.33,59.03,770.98,59.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1244.04,471.87c0,260.55-212.89,471.83-475.5,471.83-83.4,0-161.75-21.3-229.87-58.71l-263.28,83.67,85.82-253.14c-43.31-71.12-68.21-154.51-68.21-243.64C293,211.26,505.89,0,768.54,0s475.5,211.26,475.5,471.87h0ZM768.54,75.15c-220.5,0-399.81,177.94-399.81,396.72,0,86.76,28.27,167.17,76.15,232.6l-49.93,147.3,153.61-48.81c63.11,41.41,138.73,65.59,219.98,65.59,220.41,0,399.77-177.95,399.77-396.68S988.95,75.15,768.54,75.15h0Zm240.12,505.39c-2.95-4.83-10.72-7.72-22.33-13.51-11.66-5.77-69-33.78-79.67-37.62-10.67-3.85-18.5-5.79-26.22,5.77-7.78,11.57-30.12,37.63-36.94,45.35-6.78,7.74-13.56,8.68-25.23,2.89-11.68-5.77-49.25-18.03-93.76-57.38-34.63-30.7-58.03-68.53-64.86-80.1-6.77-11.56-.67-17.81,5.1-23.58,5.26-5.21,11.68-13.51,17.5-20.23,5.84-6.78,7.78-11.62,11.66-19.35,3.89-7.72,1.95-14.45-1-20.23-2.89-5.77-26.22-62.69-35.95-85.87-9.66-23.11-19.39-22.25-26.22-22.25s-19.36,2.02-19.36,2.02c0,0-23.37,2.89-34.03,14.46-10.67,11.56-40.78,39.57-40.78,96.43s41.73,111.93,47.56,119.6c5.84,7.74,80.61,128.33,199.12,174.64,118.51,46.29,118.51,30.85,139.89,28.9,21.34-1.88,68.95-27.96,78.68-54.97,9.73-27.01,9.73-50.18,6.83-54.97h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 11,
    y: 1067.77,
    width: 1497.43,
    height: 329.19,
    rx: 138.67,
    ry: 138.67
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(185.9 1285.46)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+569 4626 3994"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIconSvg);
export default __webpack_public_path__ + "static/media/whatsapp_icon_svg.74481f80.svg";
export { ForwardRef as ReactComponent };